<div style="height: 100vh; display: flex; flex-direction: column; justify-content: space-between;">
    <div class="container container-lg-fluid col-12 col-xl-10 mt-3 mt-lg-5">
        <div class="
          col-12 col-lg-4 mb-lg-5
          d-flex
          justify-content-lg-start justify-content-center
        ">
            <img class="img" src="../../../assets/images/adameva_long_logo.png" alt="" />
        </div>
        <div class="col-12 d-flex flex-column flex-lg-row mt-5">
            <div class="col-12 col-lg-6 me-lg-5 mt-4">
                <!-- <p class="fw-bold">Søknadsskjema for frisør</p> -->
                <img class="img" src="../../../assets/images/2.jpg" alt="" />
            </div>
            <div class="
            col-12 col-lg-6
            my-4 my-lg-0
            d-flex
            flex-column
            justify-content-lg-center
            align-items-center align-items-lg-start
          ">
                <h1 class="fw-bold login-title">GÅ TIL SØKNADSSKJEMA HER</h1>
                <div class="col-xl-10 d-flex flex-column">
                    <p class="fw-bold fs-6 my-3">
                        Søknaden tar ca. et par minutter å fylle ut.<br> Logg inn med Vipps for en enda enklere registrering:
                    </p>
                    <button class="btn btn-danger py-3 col-12" type="button" (click)="vippsAuthorize()">
                        <span class="me-2">Fortsett med</span>
                        <img src="../../../assets/images/Vipps_logo.svg" alt="" />
                    </button>
                    <p class="fw-light text-center small mt-3 mb-4">
                        Det er helt gratis å søke på våre studier. </p>
                    <a role="button" class="btn btn-primary mt-md-4" (click)="formAuthorize()">
                        Søk uten å logge inn
                    </a>
                </div>
            </div>
        </div>
    </div>
    
    <footer class="container mb-4">
        <div class="row">
            <div class="col-10 offset-1 text-center">
                <img src="../../../assets/images/Logo_A&E_XS.png" class="my-2" alt="ADAM OG EVA SKOLE OG AKADEMI" />
    
                <p class="small lh-base">
                    <strong>Adam og Eva Skolen AS</strong><br />
                    Tlf:
                    <a href="tel:23135090" title="Ring oss gjerne om du lurer på noe">+47 23 13 50 90</a>
                    | E-post:
                    <a href="mailto:skolen@adamogeva.no" title="Send oss en e-post">skolen@adamogeva.no</a>
                    <br />
                    Postadresse: Adam og Eva Skolen AS, Schweigaardsgate 14, 0185 Oslo |
                    Besøksadresse: Tøyenbekken 21, 0185 Oslo<br />
                    Org.nr.: 938 371 547
                </p>
                <p class="">
                    <a class="mr-4" href="https://www.facebook.com/adamogevaskoleogakademi" title="Besøk oss på Facebook"><img src="../../../assets/images/Icon simple-facebook.png" alt="Facebook" /></a>
                    <span>&nbsp;&nbsp;</span>
                    <a class="ml-4" href="https://www.instagram.com/adamogevaakademiet/" title="Besøk oss på Instagram"><img src="../../../assets/images/Icon simple-instagram.png" alt="Instagram" /></a>
                </p>
            </div>
        </div>
    </footer>
</div>